/* eslint-disable import/no-unresolved */
import { Grid } from '@mui/material';
import { grey } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  link: {
    textDecoration: 'none',
  },
  poweredBy: {
    fontSize: theme.spacing(7 / 4),
    fontWeight: 500,
    color: grey[600],
  },
  logo: {
    width: '8rem',
  },
}));

const href = 'https://hivemanager.io';

const HiveFootPrint = () => {
  const {classes, cx} = useStyles();

  return (
    <Grid container className={classes.root}>
      <Grid item>
        <a
          href={href}
          rel="noreferrer"
          target="_blank"
          className={cx(classes.link, classes.poweredBy)}
        >
          Powered by Hivemanager App
        </a>
      </Grid>
      <Grid item>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className={classes.link}
        >
          <img
            src={`${typeof window !== 'undefined' ? window.hmAssetsPath || '' : ''}/logo_new.png`}
            className={classes.logo}
            alt="logo"
          />
        </a>
      </Grid>
    </Grid>
  );
};

export default HiveFootPrint;
